enum NFTRoutes {
  NFTs = 'nfts',
}

export default NFTRoutes;
